<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { ContactOrderPlanRow } from "../../../../_logic/communication-plan-table-contract"

  let { row }: { row: ContactOrderPlanRow } = $props()
</script>

{#if row.hint}
  <span class="hint-cell">
    <StatusTag
      size="sm"
      label={row.hint.label}
      subLabel={row.hint.subLabel ?? ""}
      icon={row.hint.icon}
      color={row.hint.color}
      tooltipContent={row.hint.tooltipHtml ?? ""}
      tooltipHtml={Boolean(row.hint.tooltipHtml)}
      tooltipClassName={row.hint.tooltipHtml ? RICH_TOOLTIP_CLASS : ""}
    />
  </span>
{:else}
  <span class="hint-cell hint-cell--empty">–</span>
{/if}

<style lang="less">
  .hint-cell {
    display: inline-flex;
    max-width: 24rem;

    :global(.status-tag) {
      max-width: 100%;
    }

    :global(.status-tag__main-label),
    :global(.status-tag__sub-label) {
      max-width: 18rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .hint-cell--empty {
    display: inline-block;
    color: color-mix(in srgb, var(--text-invers-100) 72%, transparent);
  }
</style>
